<template>
    <div>
      <vmodal name="addSeriesModal" height="auto" width="800">
          <div class="card">
              <div class="card-content">
                <div class="modal-header">
                    <p>{{ $t('invoice.addSeries') }}</p>
                </div>
                <div class="modal-body">
                  <form class="clearfix row">
                        <div class="col-md-12">
                            <div class="form-group">
                              <div class="row">
                                <div class="col-md-12" style="margin-top: 15px;">
                                  <div class="form-group">
                                    <label>{{ $t('gestiune.locatie') }}</label>
                                    <select class="form-control" v-model="selectedLocationSeries">
                                      <option value="" disabled>Selectează locația</option>
                                      <optgroup
                                        v-for="group in groupedLocations"
                                        :key="group.vat"
                                        :label="`VAT: ${group.vat}`"
                                      >
                                        <option
                                          v-for="loc in group.locations"
                                          :key="loc.true_id"
                                          :value="loc"
                                        >
                                          {{ loc.name }}
                                        </option>
                                      </optgroup>
                                    </select>
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <label>{{ $t('invoice.type') }}</label>
                                    <select class="form-control" v-model="tip">
                                      <option value="" disabled>Selectează optiunea</option>
                                      <option value="NIR">NIR</option>
                                      <option value="Bon de transfer">Nota transfer</option>
                                      <option value="Bon consum">Bon consum</option>
                                      <option value="Bon de productie">Bon de productie</option>
                                      <option value="Inventar">Inventar</option>
                                      <option value="Invoice">Invoice</option>
                                      <option value="Proforma">Proforma</option>
                                      <option value="Aviz">Aviz</option>
                                      <option value="Order">Order</option>
                                      <option value="Casare">Casare</option>
                                    </select>
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <label>{{ $t('invoice.series') }}</label>
                                    <input type="text" @input="series = series.replace(/[^a-zA-Z0-9]/g, '')" :placeholder="$t('invoice.series')" class="form-control" v-model="series" />
                                  </div>
                                </div>
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <label>{{ $t('invoice.startNumber') }}</label>
                                    <input
                                      type="number"
                                      :placeholder="$t('invoice.startNumber')"
                                      class="form-control"
                                      v-model.number="startNumber"
                                      min="0"
                                    />
                                  </div>
                                </div>
                                <!-- <div class="col-md-6">
                                  <div class="form-group">
                                    <label>{{ $t('invoice.endNumber') }}</label>
                                    <input type="number" :placeholder="$t('invoice.endNumber')" class="form-control" v-model="endNumber" />
                                  </div>
                                </div> -->
                              </div>
                            </div>
                        </div>
                  </form>
                </div>
                <div class="modal-footer">
                  <div class="button-group">
                    <a @click="closeSeriesModal" class="btn btn-danger btn-icon mar-rt-10 delete">{{ $t('general.cancel2') }}</a>
                    <button @click.prevent="saveSeries" class="btn btn-icon btn-success mar-rt-10 save">{{ $t('general.save') }}</button>
                  </div>
                </div>
              </div>
          </div>
      </vmodal>
    </div>
</template>

  <script>
    import swal from 'sweetalert2'

    export default {
      props: {
        locations: {
          type: Array,
          required: true
        },
        groupedLocations: {
          type: Array,
          required: true
        },
        vatNumber: String
      },
      data () {
        return {
          selectedLocationSeries: '',
          editSeriesId: null,
          series: '',
          startNumber: null,
          endNumber: null,
          tip: ''
        }
      },
      created () {
        this.companyID = this.$session.get('selectedCompany')
      },
      watch: {
        startNumber (value) {
          if (value === 0) {
            this.startNumber = 1
          }
        }
      },
      methods: {
        openSeriesModal () {
          this.editSeriesId = null
          this.tip = ''
          this.series = ''
          this.startNumber = ''
          this.endNumber = ''

          this.$modal.show('addSeriesModal')
        },
        closeSeriesModal () {
          this.$modal.hide('addSeriesModal')
        },
        async saveSeries () {
          if (!this.series || !this.startNumber || !this.tip) {
            swal({
              title: 'Error',
              text: 'All fields are required for the series.',
              type: 'error',
              timer: 1500,
              showConfirmButton: false
            })
            return
          }

          let mappedTip = ''
          switch (this.tip) {
            case 'NIR':
              mappedTip = 'nir'
              break
            case 'Nota de consum':
              mappedTip = 'nota_de_consum'
              break
            case 'Bon consum':
              mappedTip = 'bon_consum'
              break
            case 'Bon de transfer':
              mappedTip = 'bon_transfer'
              break
            case 'Bon de productie':
              mappedTip = 'bon_productie'
              break
            case 'Inventar':
              mappedTip = 'inventar'
              break
            case 'Invoice':
              mappedTip = 'invoice'
              break
            case 'Proforma':
              mappedTip = 'proforma'
              break
            case 'Aviz':
              mappedTip = 'aviz'
              break
            case 'Order':
              mappedTip = 'order'
              break
            case 'Casare':
              mappedTip = 'bon_casare'
              break
            default:
              mappedTip = this.tip
          }

          const seriesData = {
            externalCompanyId: this.companyID,
            externalLocationId: this.selectedLocationSeries.true_id,
            vatNumber: this.selectedLocationSeries.inv_fiscal_code,
            series: this.series,
            startNumber: this.startNumber,
            endNumber: this.endNumber || 999999,
            tip: mappedTip
          }

          try {
            // Salvează seria
            const seriesResponse = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/series`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(seriesData)
            })

            if (!seriesResponse.ok) {
              throw new Error('Error saving series')
            }

            const seriesDataResponse = await seriesResponse.json()
            console.log('Series saved successfully:', seriesDataResponse)

            this.$modal.hide('addSeriesModal')

            swal({
              title: 'Succes',
              text: 'Seria a fost salvată cu succes.',
              type: 'success',
              timer: 1500,
              showConfirmButton: false
            })

            this.$emit('getSeries', this.vatNumber)
          } catch (error) {
            console.error('Error saving series:', error)

            swal({
              title: 'Error',
              text: error.message,
              type: 'error',
              timer: 1500,
              showConfirmButton: false
            })
          }
        }
      }
    }
  </script>

<style scoped>
.default-label {
  background-color: orange;
  color: white;
  font-size: 11px;
  padding: 2px 6px;
  margin-left: 8px;
  border-radius: 6px;
  font-weight: bold;
  display: inline-block;
}
a.btn.delete {
  width: auto;
}
a.btn.delete.mar-rt-10.disabled {
    width: auto;
    border-color: #FF0D19;
}
.form-check {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}
.action-buttons {
display: flex;
justify-content: space-between;
align-items: center; /* Aliniază butoanele pe axa verticală */
margin-bottom: 15px;
}

.left-buttons {
display: flex;
}

.left-buttons el-button {
margin-right: 10px; /* Spațiere între butoane */
}

.right-button {
margin-left: auto; /* Asigură că butonul "Editare Multipla" se aliniază la dreapta */
}
.button-group {
  display: flex; /* Folosește flexbox pentru alinierea orizontală */
  justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
  margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
  margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
.info-text {
  margin-bottom: 20px;
  font-size: 13px;
  font-weight: 400;
  color: #000;
  background-color: white;
  padding: 7px 10px;
  border-radius: 9px;
  box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/ManagementSeriesAdd.vue